module.exports = __webpack_public_path__ + "img/forward.eaad7f87.svg";